import { doc, RM } from "./util.js";

// TOC buttons: [data-jump="id"] scroll to + focus the target.
export function initJump() {
  doc.addEventListener("click", (e) => {
    const j = e.target.closest("[data-jump]");
    if (!j) return;
    const t = doc.getElementById(j.getAttribute("data-jump"));
    if (!t) return;
    t.scrollIntoView({ behavior: RM ? "auto" : "smooth", block: "start" });
    t.focus({ preventScroll: true });
  });
}
